// メッセージ定義書.xlsxに記載されている内容（そもそも設計と合っていないし、IDのルールも微妙、一旦MSGは必ずつける。あと区切りで_をつける）
export const MSG_I_00001 = '保存しました。';
export const MSG_I_00002 = '削除が完了しました。';
export const MSG_I_00003 = 'ロックしました。';
export const MSG_I_00004 = 'ロック解除しました。';
export const MSG_I_00005 = 'ロックされました。';
export const MSG_I_00006 = 'ロック解除されました。';
export const MSG_I_00007 = 'タイムアウト。ロック解除されました。';
export const MSG_I_00008 = 'ネットワーク不良により、保存内容を保留します。';
export const MSG_I_00009 = 'ローカルデータをサーバに保存しました。';
export const MSG_I_00010 = 'オフラインのため機能が制限されます。';
export const MSG_I_00011 = 'ローカルデータが見つかりました。自動保存を行います。';
export const MSG_I_00012 = 'BOXのフォルダの作成を開始しました。';
export const MSG_I_00013 = 'パスワードを変更しました。';
export const MSG_I_00014 = '選択しました。';
export const MSG_I_00015 = 'お知らせはありません。';
export const MSG_I_00016 = '警告はありません。';
export const MSG_I_00017 = '更新が完了しました。';
export const MSG_I_00018 = '送信頻度が「即時」で 送信条件に「進捗遅延」を設定した場合、メールは0時頃に送信されます。';
export const MSG_I_00019 = '更新データがありません。';
export const MSG_I_00020 = 'プロジェクトデータの作成が完了しました。<br/>コピー項目設定に応じて現在データをコピーしております。<br/>数分かかる場合がございますのでご了承ください。<br/>コピー状況は、プロジェクトマスタ一覧のコピー状況列でご確認いただけます。<br/>※1.コピーが完了するまで、新規のデータ作成はご遠慮ください。<br/>※2.コピーが完了しない場合やコピー状況列にエラーが表示されている場合は<br/>恐れ入りますが、システム管理者までお問い合わせください。';
export const MSG_I_00021 = 'マスタデータのコピーを開始しました。';
export const MSG_I_00022 = 'クリップボードにURLをコピーしました。';
export const MSG_I_00023 = '取込が正常に完了しました。';
export const MSG_I_00024 = '削除を受け付けました。';
export const MSG_I_00025 = '{0}を{1}しています。少々お待ちください。';
export const MSG_I_00026 = 'サマリ集計が完了しました。';
export const MSG_I_00027 = 'プラント位置情報設定画面を立ち上げました。';

//---------
export const MSG_Q_00001 = '保存されていないデータがあります。移動してもよろしいですか？';
export const MSG_Q_00002 = '削除します。よろしいですか？';
export const MSG_Q_00003 = 'ローカルデータが見つかりました。既に変更データが更新されています。<br/>ローカルデータで上書きしますか？<br/>※上書きしない場合は、ローカルデータは破棄されます。';
export const MSG_Q_00004 = 'メールが送信されなくなります。よろしいですか？';
export const MSG_Q_00005 = 'モードを切り替えます。よろしいですか？';
export const MSG_Q_00006 = '初期テンプレートを取得します。よろしいですか？';
export const MSG_Q_00007 = 'このページから移動しますか？\n行った変更が保存されない可能性があります。';
export const MSG_Q_00008 = '削除処理を受け付けました。完了には数分かかる場合がございますのでご了承ください。';
export const MSG_Q_00009 = 'リセットします。よろしいですか？';
export const MSG_Q_00010 = '並び替えを行うと、保存ができなくなります。よろしいですか？';
export const MSG_Q_00011 = '並び替えを行うと、変更した内容は保存されません。よろしいですか？';



//export const MSG_Q_00003 = '送信条件が設定されていないデータがあります。移動してもよろしいですか？';
//export const MSG_Q_00004 = '送信先が設定されていないデータがあります。移動してもよろしいですか？';
//
//export const MSG_Q_00006 = '送信先が設定されていません。よろしいですか？';

//---------
export const MSG_W_00001 = '対象データがありません。';
export const MSG_W_00002 = 'データが多すぎるため表示することができません。プラントグループを選択して読込を行ってください。';
export const MSG_W_00003 = '対象のプラントカテゴリ会社行を選択してください。';
export const MSG_W_00004 = '保存されていないデータがあります。保存後、当初計画を確定してください。';
export const MSG_W_00005 = '他ユーザ（{0} さん）が編集中のため、ロックできません。';
export const MSG_W_00006 = '{0}が未入力です。';
export const MSG_W_00007 = '{0}には{1}以降の日付を入力してください。';
export const MSG_W_00008 = '前の作業が完了していません。';
export const MSG_W_00009 = 'オフラインのため機能制限されています。';
export const MSG_W_00010 = '機器を選択してください。';
export const MSG_W_00011 = '有効な機器を先に選択してください。';
export const MSG_W_00012 = '無効な設定のため、{0}へ遷移できません。';
export const MSG_W_00013 = 'オフラインのため{0}を中断します。';
export const MSG_W_00014 = 'オフラインのため{0}できません。';
export const MSG_W_00015 = 'サマリ集計処理でエラーが発生しました。もう一度集計を実行してください。';
export const MSG_W_00016 = '事前申請で既に承認済のデータは、実行選択できません。'; 
export const MSG_W_00017 = 'プロジェクトとサイトが紐づけられていないため、プラント位置情報設定画面を立ち上げることができません。';
export const MSG_W_00018 = 'プラント位置情報が既に設定されているため、先にプラント位置情報を削除してください。'; 

//export const MSG_W_00001 = '{0}が登録されていません。';
//export const MSG_W_00004 = '{0}及び{1}のいずれかを入力してください。';
//export const MSG_W_00005 = '{0}及び{1}に紐づくデータは存在しません。';
//export const MSG_W_00009 = '他のユーザによって更新された情報が存在します。';

//---------

export const MSG_E_00001 = 'システムエラーが発生しました。管理者に連絡してください。';
export const MSG_E_00002 = '入力エラーがありました。';
export const MSG_E_00003 = '{0}は入力必須です。';
export const MSG_E_00004 = '入力必須です。';
export const MSG_E_00005 = '{0}は既に使用されています。'; // ログインID
export const MSG_E_00006 = '{0}はユーザ間で重複した指定がされています。'; // メールアドレス
export const MSG_E_00007 = '新しいパスワードと新しいパスワード(確認)が異なります。';
export const MSG_E_00008 = 'パスワードはログインIDと異なる内容を指定してください。';
export const MSG_E_00009 = '前回までと同じパスワードは指定できません。';
export const MSG_E_00010 = 'このアカウントは現在、ロックされています。管理者へお問い合わせください。';
export const MSG_E_00011 = 'ファイルが選択されていません。';
export const MSG_E_00012 = 'ファイルフォーマットが不正です。';
export const MSG_E_00013 = '{0}シートが存在しません。';
export const MSG_E_00014 = '下記のいずれかの列が存在しません。<br/>{0}';
export const MSG_E_00015 = '{0}は{1}で入力してください。';
export const MSG_E_00016 = '{0}は{1}文字以内で入力してください。';
export const MSG_E_00017 = '{0}が重複しています。';
export const MSG_E_00018 = '{0}と{1}の組み合わせが重複しています。';
export const MSG_E_00019 = 'エクスポートに失敗しました。';
export const MSG_E_00020 = '選択したファイルを読み込めませんでした。<br/>選択ファイルを確認の上、再度お試しください。<br/>それでも改善されない場合は、システム管理者へお問い合わせください。';
export const MSG_E_00021 = '読み込み対象のデータが存在しません。';
export const MSG_E_00022 = '入力された検索条件名は既に使用されています。';
export const MSG_E_00023 = '{0}：{1}が選択されていないためコピーできません。';
export const MSG_E_00024 = '有効なデータが0件になるような登録はできません。';
export const MSG_E_00025 = 'システム管理者が0件になるような登録はできません。';
export const MSG_E_00026 = 'ログインユーザ自身のデータを削除、または無効化することはできません。';
export const MSG_E_00027 = 'ログインユーザ自身のデータを削除することはできません。';
export const MSG_E_00028 = '{0}には{1}以降の日付を入力してください。';
export const MSG_E_00029 = '{0}の組み合わせは未登録です。';
export const MSG_E_00030 = '承認情報の入力期間外のため、保存できない承認情報があります。保存できなかったプラント-カテゴリ-会社は以下の通りです。プラント名：{0}　カテゴリ名：{1}　会社：{2}';
export const MSG_E_00031 = '担当の作業項目以外の変更はできません。';
export const MSG_E_00032 = '設問が回答されている{0}は削除できません。';
export const MSG_E_00033 = '同一機器内で、テスト系統が重複しています。';
export const MSG_E_00034 = '同一機器内で、法規が重複しています。';
export const MSG_E_00035 = '{0}に未来日付は入力できません。';
export const MSG_E_00036 = '前の作業が完了していません。';
export const MSG_E_00037 = '{0}を「プロジェクト開始日、終了日」の範囲内にしてください。';
export const MSG_E_00038 = '1件以上選択してください。';
export const MSG_E_00039 = '{0}に不正な値が入力されています。';
export const MSG_E_00040 = '{0}から{1}の間で指定してください。';
//export const MSG_E_00041 = '日付形式が不正です。';
export const MSG_E_00042 = '{0}桁以内で入力してください。';
export const MSG_E_00043 = '{0}以上の整数を入力してください。';
export const MSG_E_00044 = '{0}を選択してください。';
export const MSG_E_00045 = '{0}は期間内に入力してください。';
export const MSG_E_00046 = '{0}は日付を入力してください。';
//export const MSG_E_00047 = '{0}に不正な値が入力されています。';
export const MSG_E_00048 = 'すでに進捗が入力されているため削除できません。';
export const MSG_E_00049 = 'グループ列が含まれているため削除できません。';
export const MSG_E_00050 = '進捗表を保存してください。';
export const MSG_E_00051 = '{0}は当日日付以降を入力してください。';
export const MSG_E_00052 = '{0}は未来日付を入力してください。';
export const MSG_E_00053 = '作業担当が限定されているため追加できません。';
export const MSG_E_00054 = '作業担当が限定されているため削除できません。';
export const MSG_E_00055 = '行／列が絞り込まれている状態の時は移動や削除ができません。絞り込みを解除してから実行してください。';
export const MSG_E_00056 = '作業担当が限定されているためグループ化できません。';
export const MSG_E_00057 = '作業担当が限定されているためグループ化の解除ができません。';
export const MSG_E_00058 = '移動する権限がありません。';
export const MSG_E_00059 = 'グループ化する権限がありません。';
export const MSG_E_00060 = 'グループ化を解除する権限がありません。';
export const MSG_E_00061 = 'ファイルアップロードサイズ上限({0})を超えているためアップロードできません。';
//export const MSG_E_00062 = '表示されていない機器が存在するため、移動できません。';
export const MSG_E_00062 = '現在表示中のプラントカテゴリ会社単位内で、全作業の進捗マークが×となり、非表示中の機器・工事Noが1つ以上あるため、機器順序を指定できません。';
export const MSG_E_00063 = '回答済の設問は編集できません。';
export const MSG_E_00064 = '自由入力欄は設問1つにつき1つのみ設定できます。';
export const MSG_E_00065 = '{0}は{1}以上の値を入力してください。';
export const MSG_E_00066 = '編集タブで保存を押下しないと{0}できません。';
export const MSG_E_00067 = '最大値を0以上で設定してください。';
export const MSG_E_00068 = '必須の項目では1以上の数値を設定してください。';
export const MSG_E_00069 = '{0}には登録されているものを入力してください。';
export const MSG_E_00070 = '入力値が不正です。';
export const MSG_E_00071 = '項目を入力した場合は選択をしてください。';
export const MSG_E_00072 = '選択した場合は項目を入力してください。';
export const MSG_E_00073 = '選択または項目を入力してください。';
export const MSG_E_00074 = '{0}は{1}以下もしくは{2}以上の値を入力してください。';
export const MSG_E_00075 = '作業が1件も選択されていません。';

export const MSG_E_00078 = 'メール文面または送信条件が未登録のため、送信設定を有効化できません。';

export const MSG_E_00081 = '他に段がないため、削除できません。';
export const MSG_E_00082 = '作業が登録されているため、削除できません。';
export const MSG_E_00083 = 'DBに保存できませんでした。';
export const MSG_E_00084 = '{0}を入力した場合は{1}を入力してください。';
export const MSG_E_00085 = '{0}が取得できませんでした。';
export const MSG_E_00086 = '他の承認者の承認は取り消しできません。';
export const MSG_E_00087 = 'Boxフォルダが作成されていません。';
export const MSG_E_00088 = 'テンプレートの構文に誤りがあります。';


export const MSG_E_00092 = '{0}には{1}以降の時刻を入力してください。';

export const MSG_E_00094 = '設定が有効なため、条件を0件にすることはできません。';
export const MSG_E_00095 = '{0}は入力できません。';
export const MSG_E_00096 = '{0}は{1}文字以上{2}文字以内で入力してください。';


export const MSG_E_00099 = '{0}は{1}文字以上で入力してください。';
export const MSG_E_00100 = '{0}は{1}以上{2}以下の値を入力してください。';
export const MSG_E_00101 = '{0}は{1}以下の値を入力してください。';
export const MSG_E_00102 = '選択系の設問には選択肢を設定してください。';
export const MSG_E_00103 = '{0}は数値を入力してください。';
export const MSG_E_00104 = '{0}は時刻を入力してください。';
export const MSG_E_00105 = '{0}には{1}より前の日付を入力してください。';
export const MSG_E_00106 = '{0}には{1}より後の日付を入力してください。';
export const MSG_E_00107 = '{0}は{1}分単位の時刻を入力してください。';

export const MSG_E_00108 = '対象データが上限（{0}件）を超えるため、条件を絞って{1}してください。';
export const MSG_E_00109 = '編集中データのためクリップボードにコピーできません。保存後に再度お試しください。';
export const MSG_E_00110 = 'プラント、カテゴリ、会社の何れかが設定されていないためクリップボードにコピーできません。';
export const MSG_E_00111 = '最新の承認情報を更新してください。';
export const MSG_E_00112 = '{0}が複数選択されています。';
export const MSG_E_00113 = '{0}権限がありません。';
export const MSG_E_00114 = '{0}文字以内で入力してください。';
export const MSG_E_00115 = '不正な{0}が選択されています。';
export const MSG_E_00116 = '既に使用されています。';
export const MSG_E_00117 = '{0}が選択されていません。';
export const MSG_E_00118 = 'エラーにより取込に失敗しました。';
export const MSG_E_00119 = '[作業ID][機器・工事ID]ファイル内で同一の機器と作業の組み合わせは設定できません。';
export const MSG_E_00120 = '[進捗情報ID]ファイル内で同一の進捗情報は設定できません。';
export const MSG_E_00121 = '[{0}]プロジェクト期間内の日付を指定してください。';
export const MSG_E_00122 = '[実績]以下のいずれかを入力してください。\n●、10 %、20 %、30 %、40 %、50 %、60 %、70 %、80 %、90 %、100 %\nまたは進捗率: 1～99の数値。';
export const MSG_E_00123 = '[進捗]以下のいずれかを入力してください。\n(空白) 、〇、◎、●、▲、△、◇、■\nまたは進捗率: 1～99の数値。\n※取込区分が追加の場合、「×」は指定不可';
export const MSG_E_00124 = '[進捗]以下のいずれかを入力してください。\n(空白) 、〇、◎、●、▲、△、×、◇、■\nまたは進捗率: 1～99の数値。';
export const MSG_E_00125 = '[{0}]不正な{1}が設定されています。';
export const MSG_E_00126 = '作業グループ内で連番になりません。同じ作業グループ内で連番となるように入力してください。';
export const MSG_E_00127 = '一度に{0}件を超えるデータを操作することはできません。複数回に分けて実行してください。';
export const MSG_E_00128 = '登録済みの機器・工事は1つしか選択できません。';
export const MSG_E_00129 = '機器に対して同一の作業 / 作業担当は選択できません。';

export const MSG_E_00130 = "登録処理を受け付けました。時間を置いてから進捗を確認してください。";
export const MSG_E_00131 = '現在日付がプロジェクト終了日を過ぎているため、プレビュー表示ができません。';

export const MSG_E_00132 = '空白(全角/半角)の入力はできません。';
export const MSG_E_00133 = '{0}は既に使用されているため、変更または削除ができません。';
export const MSG_E_00134 = '所属会社の担当者を指定してください。';
export const MSG_E_00135 = '{0}のセルを1つ選択してください。';

export const MSG_E_00142 = '複数の担当者を{0}とする場合、連続したセルを指定してください。';
export const MSG_E_00143 = '{0}に{1}と同一の値を設定できません。'; 
export const MSG_E_00144 = '初期値は、入力形式が文字列以外の場合は設定できません。\n入力形式に「数値のみ」、「日付」、「時刻」が選択されているため、「文字列」へ変更ください。'; 
export const MSG_E_00145 = '{0}に所属会社以外が含まれているため、削除できません。'; 
export const MSG_E_00146 = '{0}に所属会社以外が含まれているため、追加できません。'; 
export const MSG_E_00147 = '{0}は、所属会社以外変更できません。'; 
export const MSG_E_00148 = '開始時刻と終了時刻が同じ場合、間隔を空白にしてください。'; 
export const MSG_E_00149 = '{0}と{1}に同一の日付を設定できません。'; 
export const MSG_E_00150 = '時刻は、次のいずれかの順序で設定してください。：1回目 < 2回目 < 3回目、3回目 < 1回目 < 2回目、または 2回目 < 3回目 < 1回目';

//export const MSG_E_00014 = '文字種が異なります。';
//export const MSG_E_00004 = 'ログインに失敗しました。';
//export const MSG_E_00010 = '入力内容がパスワードポリシーを満たしていません。（{0})';
//export const MSG_E_00020 = '先に{0}が更新されました。最新の情報を取得して再度保存してください。';
//export const MSG_E_00035 = '計画開始日と計画終了日が間違っています。';
//export const MSG_E_00037 = 'テスト系統：｛0｝はテスト系統の登録値と異なります。';
//export const MSG_E_00043 = '{0}の値は{1}に存在しません。';
//export const MSG_E_00047 = '次のプラントのHW期間が逆転しています。{0}';
//export const MSG_E_00048 = '次のプラントのHW期間が設定されていません。{0}';
//export const MSG_E_00049 = '次のプラントのHW期間が正しくありません。{0}';
//export const MSG_E_00050 = '次のプラントのHW期間が作成可能期間を超えています。{0}';
//export const MSG_E_00056 = '運用チェックを入力した場合は{0}を入力してください。';
//export const MSG_E_00059 = '{0}は{1}以前に設定してください。';